import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { ProfileService } from '../../../core/services/profile/profile.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'profile-create',
  imports: [
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatSlideToggle,
  ],
  templateUrl: './profile-create.component.html',
  styleUrl: './profile-create.component.scss',
  standalone: true,
  providers: [ProfileService],
})
export class ProfileCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private snackbar: SnackbarCustomService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  @Output() responseCreate = new EventEmitter()

  ngOnInit(): void {
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      active: [true],
    })
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.profileService.createProfile(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.createForm()
        this.responseCreate.emit(true)
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  createModel() {
    return {
      statusId: this.form.get('active')?.value == true ? 1 : 2,
      descricao: this.form.controls['description'].value,
    }
  }
}
